import React, { useEffect, useState, useRef, useMemo } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import cx from "classnames";
import styles from "./index.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";

export default observer(({ data, className }) => {
  const t = useTranslation();
  const { finance } = useStore();

  //将data转化为组件selfData
  const selfData = useMemo(() => {
    const convertData = {
      label: data,
    };
    return convertData;
  }, [data]);

  return <div className={cx(styles.main, className)}>{selfData.label}</div>;
});
